export default "__VITE_ASSET__Bqo097Fq__"